import { CashCount } from "../CashCount";
import { Installation } from "../Installation";
import { MachineContent } from "./MachineContent";
import { VirtualSafeContent } from "./VirtualSafeContent";

export class InstallationContent extends Installation {
    /** Lista di machine content, informazioni specifiche sul contenuto di ogni macchina */
    contentMachines: MachineContent[] = [];

    /** Installation content  */
    content: CashCount = null;

    /** Virtual safe content */
    virtualSafeContent: VirtualSafeContent;

    machinesBagFillingPercentage: Map<string, number>;

    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);

        if (obj.ContentMachines && obj.ContentMachines.length > 0) {
            obj.ContentMachines.forEach((e) => {
                let ms: MachineContent = new MachineContent();
                ms.parse(e);
                ms.model = this.machines.find((c) => c.serialNumber == ms.machineSerialNumber).model;
                this.contentMachines.push(ms);
            });
        }

        if (obj.Content) {
            this.content = new CashCount();
            this.content.parse(obj.Content);
        }

        if (obj.VirtualSafeContent) {
            this.virtualSafeContent = new VirtualSafeContent();
            this.virtualSafeContent.parse(obj.VirtualSafeContent);
        }

        if (obj.MachinesBagFillingPercentage) {
            this.machinesBagFillingPercentage = new Map<string, number>();
            Object.entries(obj.MachinesBagFillingPercentage).forEach((pair: any) => {
                this.machinesBagFillingPercentage.set(pair[0], pair[1]);
            });
        }
    }
}
